import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Stack,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Select,
  Textarea,
  Text,
  useToast,
} from "@chakra-ui/react";
import { ModalShell } from "../../../shared/ui";
import { feedbackSchema } from "../schemas/feedbackSchema";
import { useSendFeedbackMutation } from "../hooks/useSendFeedbackMutation";
import { CATEGORIAS_FEEDBACK } from "../api/feedbackApi";

// Sem categoria pré-selecionada: um valor padrão enviesaria a triagem no painel admin.
const EMPTY_VALUES = { category: "", message: "" };

// page é a rota em que o médico estava ao abrir o modal — vai junto do feedback para o
// time entender o contexto de um "isso não funciona" sem precisar perguntar.
export default function FeedbackModal({ isOpen, onClose, page }) {
  const toast = useToast();
  const mutation = useSendFeedbackMutation();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(feedbackSchema),
    defaultValues: EMPTY_VALUES,
  });

  const fechar = () => {
    reset(EMPTY_VALUES);
    onClose();
  };

  const onSubmit = (data) => {
    mutation.mutate(
      { ...data, page },
      {
        onSuccess: () => {
          toast({
            title: "Feedback enviado",
            description: "Obrigado! Sua mensagem vai direto para o time do MedStation.",
            status: "success",
            duration: 4000,
          });
          fechar();
        },
        onError: (error) =>
          toast({
            title: "Não foi possível enviar o feedback",
            description: error.response?.data?.mensagem,
            status: "error",
            duration: 5000,
            isClosable: true,
          }),
      }
    );
  };

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={fechar}
      title="Enviar feedback"
      onSubmit={handleSubmit(onSubmit)}
      submitLabel="Enviar"
      isSubmitting={mutation.isPending}
    >
      <Stack spacing={4}>
        <Text fontSize="sm" color="app-muted-fg">
          Conte o que está funcionando, o que atrapalha ou o que você gostaria de ver no MedStation.
        </Text>

        <FormControl isInvalid={Boolean(errors.category)}>
          <FormLabel>Categoria</FormLabel>
          <Select placeholder="Selecione…" {...register("category")}>
            {CATEGORIAS_FEEDBACK.map((c) => (
              <option key={c.value} value={c.value}>
                {c.label}
              </option>
            ))}
          </Select>
          <FormErrorMessage>{errors.category?.message}</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={Boolean(errors.message)}>
          <FormLabel>Mensagem</FormLabel>
          <Textarea autoFocus rows={5} maxLength={2000} {...register("message")} />
          <FormErrorMessage>{errors.message?.message}</FormErrorMessage>
        </FormControl>
      </Stack>
    </ModalShell>
  );
}
